IREP.seoBlogs = (function () {
    "use strict";

    var options;

    var init = function () {
        //$(document).ready(function () {
        //    var url = window.location.protocol + "//" + window.location.host + "/blogs";
        //    console.log(url + "?search=" + $(".blog_search_box").val().trim());
        //});
        
        $(".seoBlogSearch").click(function () {
            if($().val().trim() != "")
            {
                var url = window.location.protocol + "//" + window.location.host + "/blogs";
                $(this).attr("href", url + "?search=" + $(".blog_search_box").val().trim());
            }
        });
    };

    return {
        init: init
    };


})();
